import { useEffect, useState } from "react";

const KEY = "kms.compare";
const EVENT = "kms-compare";
export const COMPARE_MAX = 2;

function read(): string[] {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? "[]");
  } catch {
    return [];
  }
}

function write(ids: string[]) {
  try {
    localStorage.setItem(KEY, JSON.stringify(ids));
  } catch {
    /* ignore */
  }
  window.dispatchEvent(new Event(EVENT));
}

/** Two-slot comparison list shared by the product page, catalog bar and compare screen. */
export function useCompare() {
  const [ids, setIds] = useState<string[]>(read);
  useEffect(() => {
    const sync = () => setIds(read());
    window.addEventListener(EVENT, sync);
    return () => window.removeEventListener(EVENT, sync);
  }, []);
  return {
    ids,
    has: (id: string) => ids.includes(id),
    toggle: (id: string) => {
      const cur = read();
      // Adding a third replaces the oldest, so the button always "works".
      write(cur.includes(id) ? cur.filter((x) => x !== id) : [...cur, id].slice(-COMPARE_MAX));
    },
    remove: (id: string) => write(read().filter((x) => x !== id)),
    clear: () => write([]),
  };
}
